module.exports = __webpack_public_path__ + "img/wolf_4.296b17f1.jpg";